import styled from 'styled-components';

const RazorpaySmartCollectContainer = styled.div`
  margin: 10px 30px;
  min-height: 100vh;
`;
const Title = styled.div`
  font-size: 27px;
  font-weight: 900;
`;
const LabelAndTextField = styled.div`
  margin: 10px 0px;
  padding: 10px 0;
  font-weight: 600;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;
const InputField = styled.div``;
const Label = styled.div`
  min-width: 200px;
  font-size: 17px;
  font-weight: 900;
`;
const Error = styled.div`
  color: red;
  font-size: 12px;
  font-weight: normal;
`;
const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const VerifyDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 17px;
  font-weight: 900;
`;
const DetailContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 5px 0;
`;
const DetailTitle = styled.div`
  min-width: 200px;
  font-size: 17px;
  font-weight: 500;
`;
const SnackbarMessage = styled.span``;
export default {
  RazorpaySmartCollectContainer,
  Title,
  InputField,
  LabelAndTextField,
  Label,
  Error,
  VerifyDetailsContainer,
  DetailContainer,
  DetailTitle,
  LoaderContainer,
  SnackbarMessage
};



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/RazorpaySmartCollect/styles.js